import React, { useEffect } from 'react';
import Modal from '@gerenciatd/next.components.modal';
import { useDispatch, useSelector } from 'react-redux';
import ExternalScripts from '@gerenciatd/next.app-controller.external-scripts';
import RouteHandler from '@gerenciatd/next.app-controller.route-handler';
import ErrorBoundary from '@gerenciatd/next.app-controller.error-boundary';
import { actions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r';
import { actions as modalsAction } from '@gerenciatd/next.app-controller.reducers-sagas.modals-reducer';
import mainSetup from '@/config/mainSetup';
import { wrapper } from '@/store';
import E500 from '@/pages/500';
import '@/styles/globalVars.css';
/* [STYLES] begins */
import '@/styles/beach.style.css';
import '@/styles/icon-label.style.css';
import '@/styles/custom-link.style.css';
import '@/styles/footer.style.css';
import '@/styles/header-r.style.css';
import '@/styles/modal.style.css';
import '@/styles/image-n.style.css';
import '@/styles/faqs-n.style.css';
import '@/styles/input.style.css';
import '@/styles/button-n.style.css';
import '@/styles/icon-label-n.style.css';
import '@/styles/picture.style.css';
import '@/styles/footer-n.style.css';
import '@/styles/text-info-n.style.css';
import '@/styles/icon.style.css';
import '@/styles/tag-link.style.css';
import '@/styles/text-info.style.css';
import '@/styles/icon-n.style.css';
/* [STYLES] ends */

const App = ({ Component, pageProps }) => {
  const dispatch = useDispatch();
  const seoInfo = useSelector((state) => state.main.currentSeo);
  const handlerModals = (args) => {
    dispatch(modalsAction.addModal(args));
  };
  useEffect(() => {
    dispatch(modalsAction.initAnchorModalListener());
  }, []);
  // Error boundary props

  return (
    <>
      <ExternalScripts />
      <RouteHandler setContextData={actions.setContextData} />
      <Modal
        key="app-modal"
        className="app-root"
        projectId={mainSetup.projectId}
        reduxDispatchActions={handlerModals}
      />
      <ErrorBoundary screen={E500}>
        <Component {...pageProps} />
      </ErrorBoundary>
    </>
  );
};

export default wrapper.withRedux(App);
